"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grayPalette = void 0;
var grayPalette = {
  white: '#FFFFFF',
  smoke: '#FAFAFB',
  // full page background, hover on table row
  heather: '#F1F1F2',
  // background sections, table headers
  sterling: '#E9E9EA',
  // subtle table lines, selected gray, card shadow
  gray: '#E2E2E3',
  // lines within a table/on white
  grey: '#E2E2E3',
  // alias for gray
  stone: '#C4C4C5',
  // line divider, disabled icons
  ash: '#A0A0A3',
  // deselected text, line on gray
  koala: '#7B7B7E',
  // secondary text on black or white
  raven: '#5A5A5D',
  // selected side navigation
  charcoal: '#3E3E3F',
  // side navigation
  jet: '#262627',
  // large area on black/line separating pages in side nav
  black: '#000000' // text, icons, line

};
exports.grayPalette = grayPalette;